import './footer.scss'
import LeadershipNetLogo from '../Ln_logo/LeadershipNetLogo/LeadershipNetLogo'

const Footer = () => (
  <footer className="site-footer">
    <div className="site-footer__inner">
      <div className="site-footer__brand">
        <LeadershipNetLogo />
      </div>

      <nav className="site-footer__nav" aria-label="Footer">
        <a href="/about">About John Behr</a>
        <a href="/implementation">Implementation Support</a>
        <a href="https://leaderbridge.com" target="_blank" rel="noopener noreferrer">
          LeaderBridge
        </a>
      </nav>
    </div>
  </footer>
)

export default Footer
